import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=0d24e41c&scoped=true&"
import script from "./file-viewer.vue?vue&type=script&lang=js&"
export * from "./file-viewer.vue?vue&type=script&lang=js&"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=0d24e41c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24e41c",
  null
  
)

export default component.exports